// src/components/modals/CustomDateModal.jsx
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./customeDate.scss";

const CustomDateModal = ({
  isOpen,
  onClose,
  onSave,
  featuredDate,
  setFeaturedDate,
  isSetting,
}) => {
  if (!isOpen) return null;

  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal">
        <h3>Select Featured Until</h3>

        <DatePicker
          selected={featuredDate}
          onChange={(date) => setFeaturedDate(date)}
          minDate={new Date()}
          dateFormat="yyyy-MM-dd"
          placeholderText="Select Featured Until"
          inline
        />

        <div className="modal-actions">
          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button
            className="feat-button"
            onClick={onSave}
            disabled={isSetting || !featuredDate}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

CustomDateModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  featuredDate: PropTypes.instanceOf(Date),
  setFeaturedDate: PropTypes.func.isRequired,
  isSetting: PropTypes.bool,
};

export default CustomDateModal;
